import { useState } from 'react'

import { Button } from '@/components/ui'
import { useToast } from '@/hooks'
import type { CaseTypeChange } from './caseDetailCells'

interface CaseTypeChangeConfirmProps {
  change: CaseTypeChange
  onConfirm: () => Promise<void>
  onCancel: () => void
}

// Shown before a case type change that would delete values in fields the new type does not have.
export const CaseTypeChangeConfirm = ({
  change,
  onConfirm,
  onCancel,
}: CaseTypeChangeConfirmProps) => {
  const [isSaving, setIsSaving] = useState(false)
  const { errorToast } = useToast()

  const confirm = () => {
    setIsSaving(true)
    onConfirm()
      .catch((error) => errorToast('Couldn’t change the case type', error))
      .finally(() => setIsSaving(false))
  }

  return (
    <div className="space-y-2 rounded-md bg-amber-50 p-3 text-sm">
      <p className="font-semibold">
        Switch this case from {change.currentCaseTypeLabel} to{' '}
        {change.caseTypeLabel}?
      </p>
      <p>
        {change.caseTypeLabel} cases do not have the fields below, so their
        values will be deleted:
      </p>
      <p className="font-medium">{change.droppedLabels.join(', ')}</p>
      <div className="flex gap-2">
        <Button
          theme="destructive"
          size="xs"
          isLoading={isSaving}
          loadingText="Changing..."
          onClick={confirm}
        >
          Switch and delete
        </Button>
        <Button
          theme="outline"
          size="xs"
          disabled={isSaving}
          onClick={onCancel}
        >
          Cancel
        </Button>
      </div>
    </div>
  )
}
